import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { Tooltip, TabContent, TabPane, UncontrolledCollapse, Accordion, AccordionBody, AccordionHeader, AccordionItem, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, Collapse, ListGroup, ListGroupItem, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import ApproveModal from "../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import SwiperCore, { FreeMode, Navigation, Thumbs } from "swiper";
import handleValidDate from "../../helpers/utils/handleValidDate";

// RangeSlider
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Flatpickr from "react-flatpickr";
import Select from "react-select";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getUom, addNewUom } from "../../store/uom/action";
import { resetProductCategoryState, getProductCategory, addNewProductCategory } from "../../store/productCategory/action";
import { resetProductBlockState, getProductBlock } from "../../store/productBlock/action";
import { resetBrandState, getBrand } from "../../store/brand/action";
import { getProductTag, addNewProductTag } from "../../store/productTag/action";
import { getProductType, addNewProductType, resetProductTypeState } from "../../store/productTypes/action";
import { getAccAccount, resetAccAccountState } from "../../store/accAccount/action";
import { resetProductState, getProduct as onGetProducts, addNewProduct as onAddNewProduct, updateProduct as onUpdateProduct, deleteProduct as onDeleteProduct, getProductLoading, resetProductCreateState } from "../../store/product/action";
import defaultImg from "../../assets/images/upload.png";
import { api } from "../../config";
import ModalInputFile from "../../Components/ModalInputFile";
import SimpleBar from "simplebar-react";

import ExportCSVModal from "../../Components/Common/ExportCSVModal";
import ExportDoc from "../../Components/Common/ExportDoc";
import { setBranchSelect, setCompanySelect } from "../../store/actions";

SwiperCore.use([FreeMode, Navigation, Thumbs]);

const PricingWidgetList = (props) => {
  return (
    <React.Fragment>
      <Col lg={3} sm={6}>
        <div className="p-2 border border-dashed rounded">
          <div className="d-flex align-items-center">
            <div className="avatar-sm me-2">
              <div className="avatar-title rounded bg-transparent text-success fs-24">
                <i className={props.pricingDetails.icon}></i>
              </div>
            </div>
            <div className="flex-grow-1">
              <p className="text-muted mb-1">{props.pricingDetails.label} :</p>
              <h5 className="mb-0">{props.pricingDetails.labelDetail}</h5>
            </div>
          </div>
        </div>
      </Col>
    </React.Fragment>
  );
};

const ProductReview = (props) => {
  return (
    <React.Fragment>
      <li className="py-2">
        <div className="border border-dashed rounded p-3">
          <div className="d-flex align-items-start mb-3">
            <div className="hstack gap-3">
              <div className="badge rounded-pill bg-success mb-0">
                <i className="mdi mdi-star"></i>
                {props.review.rating}
              </div>
              <div className="vr"></div>
              <div className="flex-grow-1">
                <p className="text-muted mb-0">{props.review.comment}</p>
              </div>
            </div>
          </div>
          {props.review.subitem && (
            <React.Fragment>
              <div className="d-flex flex-grow-1 gap-2 mb-3">
                {props.review.subitem.map((subItem, key) => (
                  <React.Fragment key={key}>
                    <Link to="#" className="d-block">
                      <img src={subItem.img} alt="" className="avatar-sm rounded object-cover" />
                    </Link>
                  </React.Fragment>
                ))}
              </div>
            </React.Fragment>
          )}

          <div className="d-flex align-items-end">
            <div className="flex-grow-1">
              <h5 className="fs-14 mb-0">{props.review.name}</h5>
            </div>

            <div className="flex-shrink-0">
              <p className="text-muted fs-13 mb-0">{props.review.date}</p>
            </div>
          </div>
        </div>
      </li>
    </React.Fragment>
  );
};
const Product = () => {
  const [modal, setModal] = useState(false);
  const [modalCategory, setModalCategory] = useState(false);
  const [modalTag, setModalTag] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [customActiveTab, setCustomActiveTab] = useState("1");
  const [productTypeList, setProductTypeList] = useState([]);
  const [pageIdx, setPageIdx] = useState(0);
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setCustomActiveTab(tab);
    }
  };
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, products, productAdded, isProductCreated, isProductSuccess, loading, error, productCategories, productCategoryLoading, productBlocks, productBlockLoading, productTags, productTagLoading, brands, brandLoading, companies, companyLoading, accAccounts, accAccountLoading, uoms, uomLoading, clientLoading, clients, productTypes, branches, branchLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    productAdded: state.Product.productAdded,
    products: state.Product.products,
    isProductCreated: state.Product.isProductCreated,
    isProductSuccess: state.Product.isProductSuccess,
    loading: state.Product.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    productCategories: state.ProductCategory.productCategories,
    productCategoryLoading: state.ProductCategory.loading,
    productBlocks: state.ProductBlock.productBlocks,
    productBlockLoading: state.ProductBlock.loading,
    productTags: state.ProductTag.productTags,
    productTagLoading: state.ProductTag.loading,
    brands: state.Brand.brands,
    brandLoading: state.Brand.loading,
    accAccounts: state.AccAccount.accAccounts,
    accAccountLoading: state.AccAccount.loading,
    uoms: state.Uom.uoms,
    uomLoading: state.Uom.loading,
    error: state.Product.error,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    productTypes: state.ProductType.productTypes,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
  }));

  const [productList, setProductList] = useState([]);
  const [productDoc, setProductDoc] = useState([]);
  const [product, setProduct] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [productTagList, setProductTagList] = useState([]);
  const [uomList, setUomList] = useState([]);
  const [accountingList, setAccountingList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [productFiles, setProductFiles] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [modalMedia, setModalMedia] = useState(false);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [branchList, setBranchList] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [selectedMulti, setselectedMulti] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [logo, setLogo] = useState(defaultImg);

  const [defaultCompanyId, setDefaultCompanyId] = useState(null);
  const [productVarian, setProductVarian] = useState([]);

  const [filters, setFilters] = useState({
    // productBranch: "",
    productBlock: "",
    productCategory: "",
    order: "",
  });

  const handleFilterChange = (e, name) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: e,
    }));
  };

  const clearFilters = () => {
    setFilters({
      // productBranch: '',
      ...filters,
      productBlock: "",
      productCategory: "",
      order: "",
    });
  };

  const productDetailsWidgets = [
    {
      id: 1,
      icon: "ri-money-dollar-circle-fill",
      label: "Price",
      labelDetail: info ? info.price : "-",
    },
    {
      id: 2,
      icon: "ri-file-copy-2-fill",
      label: "No. of Orders",
      labelDetail: info ? info.orders : "-",
    },
    {
      id: 3,
      icon: "ri-stack-fill",
      label: "Available Stocks",
      labelDetail: info ? info.stocks : "-",
    },
    {
      id: 4,
      icon: "ri-inbox-archive-fill",
      label: "Total Revenue",
      labelDetail: info ? info.price_cogs : "-",
    },
  ];

  function handleMulti(selectedMulti) {
    setselectedMulti(selectedMulti);
  }
  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const statusVisibilityData = [
    {
      options: [
        { label: "Visible", value: "Visible" },
        { label: "Hidden", value: "Hidden" },
      ],
    },
  ];

  const [cate, setCate] = useState("all");
  const categories = (category) => {
    let filteredProducts = products;
    if (category !== "all") {
      filteredProducts = products.filter((product) => product.brandId === category);
    }
    setProductList(filteredProducts);
    setCate(category);
  };

  const onUpdate = (value) => {
    setProductList(products.filter((product) => product.price >= value[0] && product.price <= value[1], (document.getElementById("minCost").value = value[0]), (document.getElementById("maxCost").value = value[1])));
  };

  const [ratingvalues, setRatingvalues] = useState([]);
  /*
  on change rating checkbox method
  */
  const onChangeRating = (value) => {
    //setProductList(productsData.filter(product => product.rating >= value));

    var modifiedRating = [...ratingvalues];
    modifiedRating.push(value);
    setRatingvalues(modifiedRating);
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredProducts = products;
      if (type !== "all") {
        filteredProducts = products.filter((product) => product.product_status.name === type);
      }
      setProductList(filteredProducts);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  // useEffect(() => {
  //   setProductList(products);
  // }, [products]);

  useEffect(() => {
    if (branchSelected) {
      dispatch(resetProductState());
      dispatch(onGetProducts({ type: 1, branchId: branchSelected?.value ?? "" }));
      handleGetProductCategory(companySelected?.value);
      handleGetProductBlock(companySelected?.value);
      handleGetProductType(companySelected?.value);
      handleGetBrand(companySelected?.value);
      handleGetAccAccount(companySelected?.value);
      handleGetUOM(companySelected?.value);
      handleGetProductTag(companySelected?.value);
      setDefaultCompanyId(companySelected?.value);
    }
  }, [branchSelected]);

  const handleGetProductCategory = (id) => {
    dispatch(resetProductCategoryState());
    dispatch(getProductCategory({ companyId: id, status: 2 }));
  };

  const handleGetProductBlock = (id) => {
    dispatch(resetProductBlockState());
    dispatch(getProductBlock({ companyId: id, status: 2 }));
  };

  const handleGetProductType = (id) => {
    dispatch(resetProductTypeState());
    dispatch(getProductType({ companyId: id, status: 2 }));
  };

  const handleGetBrand = (companyId) => {
    dispatch(resetBrandState());
    dispatch(getBrand({ companyId: companyId, status: 2 }));
  };

  const handleGetUOM = (companyId) => {
    dispatch(getUom({ companyId: companyId, status: 2 }));
  };

  const handleGetAccAccount = (companyId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
  };

  const handleGetProductTag = (companyId) => {
    dispatch(getProductTag({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    if (!isEmpty(products)) {
      let filteredProducts = products;
      if (activeTypeTab !== "all") {
        filteredProducts = products.filter((product) => product.product_status.name === activeTypeTab);
      }
      setProductList(filteredProducts.map((el) => ({ ...el, isChecked: false })));
      setIsEdit(false);
      setInfo(products[products.length - 1]);
    }
  }, [products]);

  useEffect(() => {
    let dataDoc = [
      { id: "name", label: "Nama", isSelected: true, data: [] },
      { id: "description", label: "Deskripsi", isSelected: true, data: [] },
      { id: "description_short", label: "Deskripsi Singkat", isSelected: true, data: [] },
      { id: "publishedat", label: "Tanggal Terbit", isSelected: true, data: [] },
      { id: "isTaxable", label: "Dikenakan Pajak", isSelected: true, data: [] },
      { id: "isContinueSelling", label: "Lanjut Dijual", isSelected: true, data: [] },
      { id: "price", label: "Harga", isSelected: true, data: [] },
      { id: "price_regular", label: "Harga Reguler", isSelected: true, data: [] },
      { id: "price_handling", label: "Harga Penanganan", isSelected: true, data: [] },
      { id: "price_book", label: "Harga Buku", isSelected: true, data: [] },
      { id: "stock_minimum", label: "Stok Minimum", isSelected: true, data: [] },
      { id: "price_cogs", label: "Harga Pokok Penjualan", isSelected: true, data: [] },
      { id: "weight", label: "Berat", isSelected: true, data: [] },
      { id: "weightType", label: "Tipe Berat", isSelected: true, data: [] },
      { id: "uom", label: "Satuan", isSelected: true, data: [] },
      { id: "sku", label: "SKU", isSelected: true, data: [] },
      { id: "barcode", label: "Barcode", isSelected: true, data: [] },
      { id: "land_excess", label: "Kelebihan Tanah", isSelected: true, data: [] },
      { id: "land_size", label: "Ukuran Tanah", isSelected: true, data: [] },
      { id: "land_price", label: "Harga Tanah", isSelected: true, data: [] },
      { id: "building_size", label: "Ukuran Bangunan", isSelected: true, data: [] },
      { id: "longitude", label: "Bujur", isSelected: true, data: [] },
      { id: "latitude", label: "Lintang", isSelected: true, data: [] },
      { id: "branch", label: "Cabang", isSelected: true, data: [] },
      { id: "brand", label: "Merek", isSelected: true, data: [] },
      { id: "company", label: "Perusahaan", isSelected: true, data: [] },
      { id: "productType", label: "Tipe Produk", isSelected: true, data: [] },
      { id: "category", label: "Kategori", isSelected: true, data: [] },
      { id: "product_block", label: "Blok", isSelected: true, data: [] },
      { id: "tag", label: "Tag", isSelected: true, data: [] },
      { id: "status", label: "Status", isSelected: true, data: [] },
      { id: "visibility", label: "Visibilitas", isSelected: true, data: [] },
      { id: "meta_title", label: "Meta Judul", isSelected: true, data: [] },
      { id: "meta_keyword", label: "Meta Kata Kunci", isSelected: true, data: [] },
      { id: "meta_description", label: "Meta Deskripsi", isSelected: true, data: [] },
      { id: "account", label: "Akun", isSelected: true, data: [] },
      { id: "accountSales", label: "Akun Penjualan", isSelected: true, data: [] },
      { id: "accountPurchase", label: "Akun Pembelian", isSelected: true, data: [] },
      { id: "client", label: "Klien", isSelected: true, data: [] },
    ];

    if (productList.length > 0) {
      productList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (key === "product_acc_account" || key === "product_acc_sales" || key === "product_acc_purchase" || key === "product_cvl_account" || key === "product_client" || key === "product_branch" || key === "product_brand" || key === "product_company" || key === "product_type" || key === "product_category" || key === "product_block" || key === "product_status" || key === "visibility") {
                doc.data.push(value?.name ?? "-");
              } else if (key === "publishedat") {
                doc.data.push(handleValidDate(value));
              } else if (key === "price" || key === "price_regular" || key === "price_book" || key === "price_handling" || key === "price_cogs" || key === "land_price") {
                doc.data.push(`Rp.${currencyFormat(value ?? 0)}`);
              } else if (key === "stock_minimum" || key === "weight" || key === "land_excess" || key === "land_size" || key === "building_size") {
                doc.data.push(`${currencyFormat(value ?? 0)}`);
              } else if (key === "description") {
                doc.data.push(value ?? "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setProductDoc(dataDoc);
  }, [productList]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  ///handleFilterChange(e, "productBranch")

  useEffect(() => {
    if (!isEmpty(brands)) {
      var data = [];
      var opt = [];
      brands.forEach((item, key) => {
        const brand_name = item.name;
        const id = item.id;
        var obj = { label: brand_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setBrandList(data);
    }
  }, [brands]);

  useEffect(() => {
    if (!isEmpty(uoms)) {
      var data = [];
      var opt = [];
      uoms.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setUomList(data);
    }
  }, [uoms]);

  useEffect(() => {
    if (!isEmpty(productTags)) {
      var data = [];
      var opt = [];
      productTags.forEach((item, key) => {
        const tag_name = item.name;
        const id = item.id;
        var obj = { label: tag_name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setProductTagList(data);
    }
  }, [productTags]);

  useEffect(() => {
    if (!isEmpty(productBlocks)) {
      var data = [];
      var opt = [];
      productBlocks.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setBlockList(data);
    }
  }, [productBlocks]);

  useEffect(() => {
    if (!isEmpty(productTypes)) {
      var data = [];
      var opt = [];
      productTypes.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setProductTypeList(data);
    }
  }, [productTypes]);

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        var obj = { label: code + " " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  useEffect(() => {
    if (!isEmpty(productCategories)) {
      var data = [];
      var opt = [];
      productCategories.forEach((item, key) => {
        const description = item.name;
        const id = item.id;
        var obj = { label: description, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setCategoryList(data);
    }
  }, [productCategories]);

  const onClickDelete = (product) => {
    setProduct(product);
    setDeleteModal(true);
  };

  const onClickApprove = (product) => {
    setProduct(product);
    setApproveModal(true);
  };

  const handleDeleteProduct = () => {
    if (product) {
      dispatch(onDeleteProduct(product));
      setDeleteModal(false);
    }
  };

  const handleApproveProduct = () => {
    if (product) {
      product.setApprove = true;
      dispatch(onUpdateProduct(product));
      setApproveModal(false);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setProduct(null);
      setProductFiles([]);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleCategory = useCallback(() => {
    if (modalCategory) {
      setModalCategory(false);
    } else {
      setModalCategory(true);
    }
  }, [modalCategory]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setInfo([]);
      setProduct(null);
      setProductFiles([]);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const validationCategory = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      brandCategory: null,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter category name").nullable(true),
      brandCategory: Yup.object().required("Please enter brand ").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(
        addNewProductCategory({
          name: values.name,
          brandId: values.brandCategory.value,
          clientId: validation.values.client.value,
          companyId: validation.values.company.value,
        })
      );
      validationCategory.resetForm();
      toggleCategory();
    },
  });

  const toggleTag = useCallback(() => {
    if (modalTag) {
      setModalTag(false);
    } else {
      setModalTag(true);
    }
  }, [modalTag]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const validationTag = useFormik({
    enableReinitialize: true,
    initialValues: {
      tag_name: "",
    },
    validationSchema: Yup.object({
      tag_name: Yup.string().required("Please enter tag name").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(addNewProductTag({ tag_name: values.tag_name }));
      validationTag.resetForm();
      toggleTag();
    },
  });

  const handleProductClick = useCallback(
    (arg, isEditProduct) => {
      const product = arg;
      let tag = [];
      var category = [];
      var varian = [];
      var option = [];

      if (defaultCompanyId !== product.companyId) {
        handleGetProductCategory(product.companyId);
        handleGetProductType(product.companyId);
        handleGetBrand(product.companyId);
        handleGetAccAccount(product.companyId);
        handleGetUOM(product.companyId);
        handleGetProductTag(product.companyId);
      }

      if (product.tag && product.tag.length) {
        product.tag.forEach((item) => {
          const tag_name = item.label;
          const id = item.value;
          var obj = { label: tag_name, value: id };
          tag.push(obj);
        });
      }

      if (product.category && product.category.length) {
        product.category.forEach((item) => {
          const name = item.label;
          const id = item.value;
          var obj = { label: name, value: id };
          category.push(obj);
        });
      }

      if (product.product_var && product.product_var.length) {
        product.product_var.forEach((item) => {
          let data = {
            id: item.id,
            price: item.price,
            price_cogs: item.price_cogs,
            price_handling: item.price_handling,
            price_regular: item.price_regular,
            land_excess: item.land_excess,
            land_size: item.land_size,
            longitude: item.longitude,
            latitude: item.latitude,

            sku: item.sku,
            barcode: item.barcode,
            image: item.image,
            option: item.pvar_options,
          };

          varian.push(data);
          if (item.pvar_options.length) {
            item.pvar_options.forEach((it) => {
              const found = option.some((opt) => opt.optionId === it.optionId);
              if (!found)
                option.push({
                  optionId: it.optionId,
                  option_name: it.pvar_option_detail.poptd_option.name,
                  sort_order: it.sort_order,
                  detail: [],
                });
            });
            item.pvar_options.forEach((it) => {
              option.forEach((op, idx) => {
                if (op.optionId === it.optionId) {
                  const founddetail = op.detail.some((optd) => optd.optionDetailId === it.optionDetailId);
                  if (!founddetail)
                    option[idx].detail.push({
                      optionDetailId: it.optionDetailId,
                      name: it.name,
                      optionId: it.optionId,
                      option_name: it.pvar_option_detail.poptd_option.name,
                    });
                }
              });
            });
          }
        });
      }

      setProductVarian(varian);

      let files = [];
      for (const f of product.product_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
      setProductFiles(files);

      setProduct({
        id: product.id,
        name: product.name,
        description: product.description,
        description_short: product.description_short,
        publishedat: product.publishedat,
        isTaxable: product.isTaxable,
        isContinueSelling: product.isContinueSelling,
        price: product.price,
        price_regular: product.price_regular,
        price_handling: product.price_handling,
        price_book: product.price_book,
        stock_minimum: product.stock_minimum,
        price_cogs: product.price_cogs,
        weight: product.weight,
        weightType: product.weightType && { label: product.weightType, value: product.weightType },
        uom: product.product_uom && { label: product.product_uom.name, value: product.product_uom.id },
        sku: product.sku,
        barcode: product.barcode,
        orders: product.orders,
        stocks: product.stocks,
        land_excess: product.land_excess,
        land_size: product.land_size,
        land_price: product.land_price,
        building_size: product.building_size,
        longitude: product.longitude,
        latitude: product.latitude,
        branch: product.product_branch && {
          label: product.product_branch.name,
          value: product.product_branch.id,
        },
        brand: product.product_brand &&
          product.product_brand.name && {
          label: product.product_brand.name,
          value: product.product_brand.id,
        },
        company: product.product_company &&
          product.product_company.name && {
          label: product.product_company.name,
          value: product.product_company.id,
        },
        productType: product.product_type &&
          product.product_type.name && {
          label: product.product_type.name,
          value: product.product_type.id,
        },
        category: product.product_category &&
          product.product_category.name && {
          label: product.product_category.name,
          value: product.product_category.id,
        },
        block: product.product_block &&
          product.product_block.name && {
          label: product.product_block.name,
          value: product.product_block.id,
        },
        tag: tag,
        status: product.product_status
          ? {
            label: product.product_status.name,
            value: product.product_status.id,
          }
          : { label: "ACTIVE", value: "2" },
        visibility: product.visibility && {
          label: product.visibility,
          value: product.visibility,
        },
        meta_title: product.meta_title,
        meta_keyword: product.meta_keyword,
        meta_description: product.meta_description,
        account: product.product_acc_account && {
          label: product.product_acc_account.name,
          value: product.product_acc_account.id,
        },
        accountSales: product.product_acc_sales && {
          label: product.product_acc_sales.name,
          value: product.product_acc_sales.id,
        },
        accountPurchase: product.product_acc_purchase && {
          label: product.product_acc_purchase.name,
          value: product.product_acc_purchase.id,
        },
        image: product.image,
        client: product.product_client &&
          product.product_client.name && {
          label: product.product_client.name,
          value: product.product_client.id,
        },
      });

      setIsEdit(isEditProduct);
      toggle();
    },
    [toggle, userType]
  );

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = productList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setProductList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        filterable: false,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = productList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setProductList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  {/* <Button color="light" className="btn-sm" onClick={() => {
                setInfo(data);
                setModalDetail(true);
              }}><i className="ri-eye-line fs-15"></i></Button> */}
                  <Button
                    color="light"
                    className={"btn-sm"}
                    onClick={() => {
                      handleProductClick(data, false);
                    }}>
                    <i className="ri-file-copy-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={"btn-sm"}
                    onClick={() => {
                      handleProductClick(data, true);
                    }}>
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteProduct") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}>
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>

              {cellProps.row.original.statusId === 1 && (
                <button
                  className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : userRole && userRole.split(",").indexOf("approveProduct") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : "btn-label btn btn-sm btn-soft-success fs-12 me-0 d-none"}
                  onClick={() => {
                    onClickApprove(data);
                  }}>
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> Approve
                </button>
              )}
            </div>
          );
        },
      },
      {
        Header: "Unit",
        accessor: "name",
        filterable: true,
        Cell: (data) => {
          let blok_name = data.row.original.product_block ? data.row.original.product_block.name : "";
          let statusData = "";
          switch (data.row.original.product_status && data.row.original.product_status.name) {
            case "DRAFT":
              statusData = <span className="badge text-uppercase badge-soft-warning">{data.row.original.product_status && data.row.original.product_status.name}</span>;
              break;
            case "ACTIVE":
              statusData = <span className="badge text-uppercase badge-soft-info">{data.row.original.product_status && data.row.original.product_status.name}</span>;
              break;
            case "INACTIVE":
              statusData = <span className="badge text-uppercase badge-soft-danger">{data.row.original.product_status && data.row.original.product_status.name}</span>;
              break;
            default:
              statusData = <span className="badge text-uppercase badge-soft-warning">{data.row.original.product_status && data.row.original.product_status.name}</span>;
              break;
          }
          return (
            <>
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-md bg-light rounded p-1">{data.row.original.image && <img src={data.row.original.image === "" ? logo : `${api.MEDIA_URL}/media/${data.row.original.image}-w-150`} alt="" className="img-fluid d-block" />}</div>
                </div>
                <div className="flex-grow-1">
                  <h5 className="fs-14 mb-1">
                    <Link
                      to="#"
                      className="text-dark"
                      onClick={() => {
                        const dt = data.row.original;
                        setInfo(dt);
                        setModalDetail(true);
                      }}
                    >
                      {blok_name} - {data.row.original.name}
                    </Link>
                  </h5>
                  <p className="text-muted mb-0">
                    {data.row.original.product_category && data.row.original.product_category.name} {data.row.original.product_block && data.row.original.product_block.name}
                  </p>
                  <p>
                    {statusData} - {handleValidDate(data.row.original.publishedat)}
                  </p>
                  {data.row.original.rating && (
                    <span className="badge bg-light text-body fs-12 fw-medium">
                      <i className="mdi mdi-star text-warning me-1"></i>
                      {data.row.original.rating}
                    </span>
                  )}
                </div>
              </div>
            </>
          );
        },
      },
      {
        Header: "Proyek",
        accessor: "product_branch.name",
        filterable: true,
      },
      {
        Header: "Pesanan",
        accessor: "orders",
        filterable: true,
        Cell: (data) => {
          return <span>{parseFloat(data.row.original.orders)}</span>;
        },
      },
      {
        Header: "Hook",
        accessor: "land_excess",
        filterable: true,
        Cell: (data) => {
          return <span>{parseFloat(data.row.original.land_excess)}</span>;
        },
      },
      {
        Header: "Harga Booking",
        accessor: "price_book",
        filterable: true,
        Cell: (data) => {
          return <span>{currencyFormat(data.row.original.price_book)}</span>;
        },
      },
      {
        Header: "Harga",
        accessor: "price",
        filterable: true,
        Cell: (data) => {
          return <span>{currencyFormat(data.row.original.price)}</span>;
        },
      },
    ],
    [productList, handleProductClick, isCheckAll]
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = productList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setProductList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => {
    return productList
      .filter((item) => {
        // const isProductBranchMatch = filters.productBranch === "" || item?.product_branch?.name === filters?.productBranch?.label;
        const isProductBlockMatch = filters?.productBlock === "" || item?.product_block?.name === filters?.productBlock?.label;
        const isProductCategoryMatch = filters?.productCategory === "" || item?.product_category?.name === filters?.productCategory?.label;
        const isOrder = filters?.order === "" || item?.orders === filters?.order;

        // Menyaring berdasarkan filter yang diisi atau menampilkan semua jika filter kosong
        return isProductBlockMatch && isProductCategoryMatch && isOrder;
      })
      .sort((a, b) => a.product_block && b.product_block && a.product_block.name.localeCompare(b.product_block.name, undefined, { numeric: true, sensitivity: "base" }));
  }, [productList, filters]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate && filterDate.split(" to ");
    if (datearr[1]) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      type: 1,
    };
    dispatch(onGetProducts(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setProductList([]);
    setSearchValue("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetProductState());
    dispatch(onGetProducts({ type: 1, branchId: branchSelected?.value ?? "" }));
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (product && product.id) || 0,
      client: (product && product.client) || clientSelected,
      company: (product && product.company) || companySelected,
      name: (product && product.name) ?? "",
      description: (product && product.description) ?? "",
      description_short: (product && product.description_short) ?? "",
      publishedat: (product && product.publishedat) ?? "",
      isTaxable: (product && product.isTaxable) || false,
      isContinueSelling: (product && product.isContinueSelling) || false,
      weight: (product && product.weight) || 0,
      weightType: (product && product.weightType) || {
        label: "Gr",
        value: "Gr",
      },
      price: (product && product.price) || 0,
      price_cogs: (product && product.price_cogs) || 0,
      price_regular: (product && product.price_regular) || 0,
      orders: (product && product.orders) || 0,
      stocks: (product && product.stocks) || 0,
      price_book: (product && product.price_book) || 0,
      price_handling: (product && product.price_handling) || 0,
      stock_minimum: (product && product.stock_minimum) || 0,
      sku: (product && product.sku) ?? "",
      barcode: (product && product.barcode) ?? "",
      brand: product && product.brand,
      productType: (product && product.productType) ?? "",
      category: product && product.category,
      block: product && product.block,
      tag: product && product.tag,
      uom: (product && product.uom) ?? "",
      status: (product && product.status) || { label: "ACTIVE", value: "2" },
      visibility: product && product.visibility,
      account: (product && product.account) ?? "",
      accountSales: (product && product.accountSales) ?? "",
      accountPurchase: (product && product.accountPurchase) ?? "",
      meta_title: (product && product.meta_title) ?? "",
      meta_keyword: (product && product.meta_keyword) ?? "",
      meta_description: (product && product.meta_description) ?? "",
      image: (product && product.image) ?? "",
      land_excess: (product && product.land_excess) || 0,
      land_size: (product && product.land_size) || 0,
      land_price: (product && product.land_price) || 0,
      building_size: (product && product.building_size) || 0,
      longitude: (product && product.longitude) ?? "",
      latitude: (product && product.latitude) ?? "",
      branch: (product && product.branch) ?? "",
      multiAddNumber: (product && product.multiAddNumber) || 0,
      isMultiAdd: (product && product.isMultiAdd) || false,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter product name").nullable(true),
      //productType: Yup.object().required("Please enter Product type").nullable(true),
      branch: Yup.object().required("Please Select Branch").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getProductLoading());
      if (isEdit) {
        const editProduct = {
          id: product ? product.id : 0,
          isMultiAdd: values.isMultiAdd,
          multiAddNumber: values.multiAddNumber,
          name: values.name,
          description: values.description,
          description_short: values.description_short,
          publishedat: values.publishedat,
          branchId: values.branch.value,
          isTaxable: values.isTaxable,
          isContinueSelling: values.isContinueSelling,
          uom: values.uom.value,
          weight: values.weight,
          weightType: values.weightType.value,
          sku: values.sku,
          barcode: values.barcode,
          accId: values.account.value,
          accSalesId: values.accountSales.value,
          accPurchaseId: values.accountPurchase.value,
          price: values.price,
          price_regular: values.price_regular,
          price_book: values.price_book,
          price_cogs: values.price_cogs,
          price_handling: values.price_handling,
          orders: values.orders,
          stocks: values.stocks,
          stock_minimum: values.stock_minimum,
          meta_title: values.meta_title,
          meta_keyword: values.meta_keyword,
          meta_description: values.meta_description,
          visibility: values.visibility && values.visibility.value,
          statusId: values.status && values.status.value,
          brandId: values.brand && values.brand.value,
          typeId: 1, //values.productType && values.productType.value,
          categoryId: values.category && values.category.value,
          blockId: values.block && values.block.value,
          companyId: values.company && values.company.value,
          tag: JSON.stringify(values.tag),
          product_varian: JSON.stringify(productVarian),
          files: productFiles.length > 0 ? productFiles : [],
          image: values.image,
          clientId: values.client.value,
          land_excess: values.land_excess,
          land_size: values.land_size,
          land_price: values.land_price,
          building_size: values.building_size,
          longitude: values.longitude,
          latitude: values.latitude,
        };
        dispatch(onUpdateProduct(editProduct));
      } else {
        const addProduct = {
          isMultiAdd: values.isMultiAdd,
          multiAddNumber: values.multiAddNumber,
          name: values.name,
          description: values.description,
          description_short: values.description_short,
          publishedat: values.publishedat,
          branchId: values.branch.value,
          isTaxable: values.isTaxable,
          isContinueSelling: values.isContinueSelling,
          uom: values.uom.value,
          weight: values.weight,
          weightType: values.weightType.value,
          sku: values.sku,
          barcode: values.barcode,
          accId: values.account.value,
          accSalesId: values.accountSales.value,
          accPurchaseId: values.accountPurchase.value,
          price: values.price,
          price_regular: values.price_regular,
          price_book: values.price_book,
          price_cogs: values.price_cogs,
          price_handling: values.price_handling,
          stock_minimum: values.stock_minimum,
          meta_title: values.meta_title,
          meta_keyword: values.meta_keyword,
          meta_description: values.meta_description,
          visibility: values.visibility && values.visibility.value,
          statusId: values.status && values.status.value,
          brandId: values.brand && values.brand.value,
          typeId: 1, //values.productType && values.productType.value,
          categoryId: values.category && values.category.value,
          blockId: values.block && values.block.value,
          companyId: values.company && values.company.value,
          tag: JSON.stringify(values.tag),
          product_varian: JSON.stringify(productVarian),
          files: productFiles.length > 0 ? productFiles : [],
          image: values.image,
          clientId: values.client.value,
          land_excess: values.land_excess,
          land_size: values.land_size,
          land_price: values.land_price,
          building_size: values.building_size,
          longitude: values.longitude,
          latitude: values.latitude,
        };
        dispatch(onAddNewProduct(addProduct));
      }
      validation.resetForm();
      toggle();
    },
  });

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteProduct(element.value));
    });
    checkall.checked = false;
  };

  const handleSelectFile = (file) => {
    switch (mediaType) {
      case "image":
        validation.setFieldValue("image", file.filename);
        break;
      case "files":
        setProductFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
      default:
        setProductFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
        break;
    }

    toggleMedia();
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = productFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setProductFiles(newState);
    } else {
      const index = productFiles.findIndex((fl) => fl.filename === file.filename);
      setProductFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  document.title = "Unit Rumah | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ApproveModal data={product && product.name ? product.name : ""} show={approveModal} onApproveClick={handleApproveProduct} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteProduct} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Produk & Jasa" pageTitle="Unit Rumah" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createProduct") !== -1 ? "btn btn-primary add-btn me-2" : "d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-archive-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger ms-1" : userRole && userRole.split(",").indexOf("deleteProduct") !== -1 ? "btn btn-soft-danger ms-1" : "btn btn-soft-danger ms-1 d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
            </button> */}
            <ExportDoc data={productDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col sm={3}>
            <Card>
              <CardHeader>
                <div className="d-flex mb-3">
                  <div className="flex-grow-1">
                    <h5 className="fs-16">Filter Unit</h5>
                  </div>
                  <div className="flex-shrink-0">
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        clearFilters();
                      }}
                      className="text-decoration-underline"
                    >
                      Hapus Semua
                    </Link>
                  </div>
                </div>
                <div className="filter-choices-input">
                  {/* <Select
                    className="mb-3"
                    placeholder={"Cabang/Proyek"}
                    value={filters.productBranch}
                    options={branchList}
                    onChange={(e) => {
                      dispatch(onGetProducts({ type: 1, branchId: e.value }));
                      handleFilterChange(e, "productBranch");
                    }}
                  /> */}
                  <Select
                    className="mb-3"
                    placeholder={"Blok"}
                    value={filters.productBlock}
                    options={blockList}
                    onChange={(e) => {
                      handleFilterChange(e, "productBlock");
                    }} />
                  <Select
                    className="mb-3"
                    placeholder={"Kategori"}
                    value={filters.productCategory}
                    options={categoryList}
                    onChange={(e) => {
                      handleFilterChange(e, "productCategory");
                    }} />
                </div>
                <div className="form-check form-switch form-switch-success" dir="ltr">
                  <Input
                    checked={filters.order === "" ? false : true}
                    type="checkbox"
                    className="form-check-input"
                    id="customSwitchsizesm2"
                    onChange={(e) => {
                      let val = "";
                      if (e.target.checked) {
                        val = "0.00";
                      }
                      handleFilterChange(val, "order");
                    }} />
                  <Label className="form-check-label" for="customSwitchsizesm2">
                    Blok Kosong
                  </Label>
                </div>
              </CardHeader>

              {/* <div className="accordion accordion-flush">
                <div className="card-body border-bottom">
                  <div>
                    <p className="text-muted text-uppercase fs-12 fw-medium mb-2">Merek</p>
                    <ul className="list-unstyled mb-0 filter-list">
                      {brands.map((item, idx) => (
                        <li key={idx}>
                          <Link to="#" className={cate === item.id ? "active d-flex py-1 align-items-center" : "d-flex py-1 align-items-center"} onClick={() => categories(item.id)}>
                            <div className="flex-grow-1">
                              <h5 className="fs-13 mb-1 listname">{item.name}</h5>
                            </div>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="card-body border-bottom">
                  <p className="text-muted text-uppercase fs-12 fw-medium mb-4">Rentang Harga</p>
                  <Nouislider range={{ min: 0, max: 2000 }} start={[0, 2000]} connect onSlide={onUpdate} data-slider-color="primary" id="product-price-range" />
                  <div className="formCost d-flex gap-2 align-items-center mt-3">
                    <input className="form-control form-control-sm" type="text" id="minCost" readOnly />
                    <span className="fw-semibold text-muted">to</span>
                    <input className="form-control form-control-sm" type="text" id="maxCost" readOnly />
                  </div>
                </div>
                <div className="card-body border-bottom">
                  <p className="text-muted text-uppercase fs-12 fw-medium mb-4">Rating</p>
                  <div className="d-flex flex-column gap-2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="productratingRadio4"
                        onChange={(e) => {
                          if (e.target.checked) {
                            onChangeRating(4);
                          } else {
                            onUncheckMark(4);
                          }
                        }}
                      />
                      <label className="form-check-label" htmlFor="productratingRadio4">
                        <span className="text-muted">
                          <i className="mdi mdi-star text-warning"></i>
                          <i className="mdi mdi-star text-warning"></i>
                          <i className="mdi mdi-star text-warning"></i>
                          <i className="mdi mdi-star text-warning"></i>
                          <i className="mdi mdi-star"></i>
                        </span>
                        4 & Above
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="productratingRadio3"
                        onChange={(e) => {
                          if (e.target.checked) {
                            onChangeRating(3);
                          } else {
                            onUncheckMark(3);
                          }
                        }}
                      />
                      <label className="form-check-label" htmlFor="productratingRadio3">
                        <span className="text-muted">
                          <i className="mdi mdi-star text-warning"></i>
                          <i className="mdi mdi-star text-warning"></i>
                          <i className="mdi mdi-star text-warning"></i>
                          <i className="mdi mdi-star"></i>
                          <i className="mdi mdi-star"></i>
                        </span>3 & Above
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="productratingRadio2"
                        onChange={(e) => {
                          if (e.target.checked) {
                            onChangeRating(2);
                          } else {
                            onUncheckMark(2);
                          }
                        }}
                      />
                      <label className="form-check-label" htmlFor="productratingRadio2">
                        <span className="text-muted">
                          <i className="mdi mdi-star text-warning"></i>
                          <i className="mdi mdi-star text-warning"></i>
                          <i className="mdi mdi-star"></i>
                          <i className="mdi mdi-star"></i>
                          <i className="mdi mdi-star"></i>
                        </span>2 & Above
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="productratingRadio1"
                        onChange={(e) => {
                          if (e.target.checked) {
                            onChangeRating(1);
                          } else {
                            onUncheckMark(1);
                          }
                        }}
                      />
                      <label className="form-check-label" htmlFor="productratingRadio1">
                        <span className="text-muted">
                          <i className="mdi mdi-star text-warning"></i>
                          <i className="mdi mdi-star"></i>
                          <i className="mdi mdi-star"></i>
                          <i className="mdi mdi-star"></i>
                          <i className="mdi mdi-star"></i>
                        </span>1
                      </label>
                    </div>
                  </div>
                </div>
              </div> */}
            </Card>
          </Col>
          <Col sm={9}>
            <Card>
              <CardBody className="pt-1">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#">
                        <i className="ri-store-line me-1 align-bottom fs-14"></i> SEMUA UNIT RUMAH
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#">
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-3 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={5}>
                            <div className="search-box me-2 mb-3 d-inline-block col-12">
                              <input
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box me-2 mb-3 col-12">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Unit Rumah" : "Tambah Unit Rumah"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <Row>
                        <Col lg={8}>
                          <div className="row">
                            <div className="mb-3 col-lg-4">
                              <Label htmlFor="client-field" className="form-label">
                                Grup Usaha&nbsp;
                                {clientLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="client"
                                value={validation.values.client}
                                isDisabled={userType === "admin" || (userType === "client") === true ? false : true}
                                placeholder="Pilih Grup Usaha"
                                onChange={(e) => {
                                  validation.setFieldValue("client", e);
                                }}
                                options={clientList}
                              ></Select>
                            </div>
                            <div className="mb-3 col-lg-4">
                              <Label htmlFor="company-field" className="form-label">
                                Perusahaan&nbsp;
                                {companyLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="company"
                                value={validation.values.company}
                                placeholder="Pilih Perusahaan"
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                onChange={(e) => {
                                  dispatch(setBranchSelect(null));
                                  dispatch(setCompanySelect(e));
                                  validation.setFieldValue("branch", "");
                                  validation.setFieldValue("company", e);
                                  setCategoryList([]);
                                  setBlockList([]);
                                  setProductTagList([]);
                                  setProductList([]);
                                  setCategoryList([]);
                                  setAccountingList([]);
                                  setUomList([]);
                                  setBrandList([]);
                                  setProductTypeList([]);
                                  setProductFiles([]);
                                  handleGetProductCategory(e.value);
                                  handleGetProductType(e.value);
                                  handleGetBrand(e.value);
                                  handleGetAccAccount(e.value);
                                  handleGetUOM(e.value);
                                  handleGetProductTag(e.value);
                                }}
                                options={companyList}
                              ></Select>
                            </div>
                            <div className="mb-3 col-lg-4">
                              <label className="form-label" htmlFor="brand">
                                Proyek / Cabang
                              </label>
                              <Select
                                name="branch"
                                placeholder="Pilih Proyek / Cabang"
                                value={validation.values.branch}
                                onChange={(e) => {
                                  dispatch(setBranchSelect(e));
                                  validation.setFieldValue("branch", e);
                                }}
                                options={branchList}
                              ></Select>
                              {validation.touched.branch && validation.errors.branch && (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.branch}
                                </small>
                              )}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <p className="mb-0">
                                <Link to="#" className="float-end text-decoration-underline d-none" onClick={() => toggleCategory()}>
                                  Tambah
                                </Link>
                                <label>Tipe</label>
                              </p>
                              <Select
                                name="category"
                                value={validation.values.category}
                                placeholder="Pilih Tipe"
                                onChange={(e) => {
                                  validation.setFieldValue("category", e);
                                }}
                                options={categoryList}
                              ></Select>
                              {validation.touched.category && validation.errors.category && (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.category}
                                </small>
                              )}
                            </div>
                            <div className="mb-3 col-lg-3">
                              <p className="mb-0">
                                <label>Blok</label>
                              </p>
                              <Select
                                name="block"
                                value={validation.values.block}
                                placeholder="Pilih Blok"
                                onChange={(e) => {
                                  validation.setFieldValue("block", e);
                                }}
                                options={blockList}
                              ></Select>
                              {validation.touched.block && validation.errors.block && (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.block}
                                </small>
                              )}
                            </div>
                            <div className="mb-3 col-lg-2">
                              <Label className="form-label" htmlFor="name">
                                Nomor Unit
                              </Label>
                              <Input type="text" className="form-control" id="name" placeholder="Isi No. Unit" name="name" value={validation.values.name ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} invalid={validation.touched.name && validation.errors.name ? true : false} />
                              {validation.touched.name && validation.errors.name && (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.name}
                                </small>
                              )}
                            </div>
                            <div className="mb-3 col-lg-4">
                              <Input name="isMultiAdd" id="isMultiAdd-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isMultiAdd} /> &nbsp;
                              <Label htmlFor="isMultiAdd-field" className="form-label">
                                Copy Jumlah Unit Otomatis
                              </Label>
                              <Input
                                type="number"
                                className="form-control"
                                id="multiAddNumber"
                                disabled={!validation.values.isMultiAdd}
                                placeholder="Jumlah Copy Unit"
                                name="multiAddNumber"
                                value={validation.values.multiAddNumber || 0}
                                onBlur={validation.handleBlur}
                                onFocus={(e) => e.target.select()}
                                onChange={(e) => {
                                  validation.setFieldValue("multiAddNumber", e.target.value);
                                }}
                              />
                            </div>
                          </div>

                          <div className="mb-3">
                            <Label>Keterangan Unit</Label>
                            <CKEditor
                              editor={ClassicEditor}
                              config={{
                                removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed"],
                              }}
                              data={validation.values.description || "<p></p>"}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                validation.setFieldValue("description", data);
                              }}
                              onReady={(editor) => {
                                const data = editor.getData();
                                validation.setFieldValue("description", data);
                              }}
                            />
                          </div>
                          <Row>
                            <Col lg={6}>
                              <div className="mb-3 d-flex justify-content-between">
                                <Label htmlFor="image" className="form-label">
                                  Gambar
                                </Label>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-label btn-soft-success"
                                  onClick={() => {
                                    setMediaType("image");
                                    toggleMedia();
                                  }}
                                >
                                  <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                                </button>
                              </div>
                              {validation.values.image !== "" ? (
                                <div className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div className="me-2">
                                      <img src={validation.values.image === "" ? logo : `${api.MEDIA_URL}/media/${validation.values.image}-w-150`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                    </div>
                                    <div className="text-truncate">{validation.values.image}</div>
                                    <div>
                                      <Link
                                        to="#"
                                        className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                        onClick={(e) => {
                                          // e.stopPropagation();
                                          validation.setFieldValue("image", "");
                                        }}
                                      >
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                            </Col>
                            <Col lg={6}>
                              <div className="mb-3 d-flex justify-content-between">
                                <Label htmlFor="taskFiles" className="form-label me-3">
                                  Dokumen Unit
                                </Label>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-label btn-soft-success"
                                  onClick={() => {
                                    setMediaType("files");
                                    toggleMedia();
                                  }}
                                >
                                  <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                                </button>
                              </div>
                              {productFiles.map((productFile, i) => {
                                if (productFile.isDeleted) {
                                  return null;
                                } else {
                                  return (
                                    <div key={i} className="border-bottom mb-3">
                                      <div className="d-flex justify-content-between mb-3 align-items-center">
                                        <div className="me-2">
                                          <img src={productFile.filename === "" ? logo : `${api.MEDIA_URL}/media/${productFile.filename}-w-150`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                        </div>

                                        <div className="text-truncate">{productFile.filename}</div>
                                        <div>
                                          <Link
                                            to="#"
                                            className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                            onClick={(e) => {
                                              // e.stopPropagation();
                                              handleDeleteFile(productFile);
                                            }}
                                          >
                                            <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                            </Col>
                          </Row>
                          <Card>
                            <CardHeader className="border-0">
                              <Nav className="nav-tabs-custom card-header-tabs border-bottom-0">
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      active: customActiveTab === "1",
                                    })}
                                    onClick={() => {
                                      toggleCustom("1");
                                    }}
                                  >
                                    Informasi Harga
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      active: customActiveTab === "2",
                                    })}
                                    onClick={() => {
                                      toggleCustom("2");
                                    }}
                                  >
                                    Informasi Meta / SEO
                                  </NavLink>
                                </NavItem>
                              </Nav>
                            </CardHeader>

                            <CardBody>
                              <TabContent activeTab={customActiveTab}>
                                <TabPane id="addproduct-general-info" tabId="1">
                                  <Row>
                                    <Col lg={6}>
                                      <div className="mb-3 col-lg-12">
                                        <label className="form-label" htmlFor="price">
                                          Harga Jual
                                        </label>
                                        <Input
                                          type="number"
                                          className="form-control"
                                          id="price"
                                          placeholder="Isi harga jual"
                                          name="price"
                                          value={validation.values.price || 0}
                                          onBlur={validation.handleBlur}
                                          onFocus={(e) => e.target.select()}
                                          onChange={(e) => {
                                            validation.setFieldValue("price", e.target.value);
                                          }}
                                        />
                                      </div>
                                      <div className="mb-3 col-lg-12 d-none">
                                        <label className="form-label" htmlFor="price_cogs">
                                          Cost of good sold
                                        </label>
                                        <Input
                                          name="price_cogs"
                                          className="form-control"
                                          id="price_cogs"
                                          placeholder="Enter price"
                                          type="number"
                                          value={validation.values.price_cogs || 0}
                                          onFocus={(e) => e.target.select()}
                                          onBlur={validation.handleBlur}
                                          onChange={(e) => {
                                            validation.setFieldValue("price_cogs", e.target.value);
                                            validation.setFieldValue("price_regular", e.target.value);
                                          }}
                                        />
                                      </div>
                                      <div className="mb-3 col-lg-12">
                                        <label className="form-label" htmlFor="price_handling">
                                          Biaya Administrasi
                                        </label>
                                        <Input type="number" className="form-control" id="price_handling" placeholder="Isi Biaya Administrasi" name="price_handling" value={validation.values.price_handling || 0} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("price_handling", e.target.value)} />
                                      </div>
                                      <div className="mb-3 col-lg-12 d-none">
                                        <label className="form-label" htmlFor="price_regular">
                                          Harga Normal
                                        </label>
                                        <Input type="number" className="form-control" id="price_regular" placeholder="Isi harga normal" name="price_regular" value={validation.values.price_regular || 0} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("price_regular", e.target.value)} />
                                      </div>
                                      <div className="mb-3 col-lg-12 d-none">
                                        <label className="form-label" htmlFor="weight">
                                          Shipping Weight
                                        </label>
                                        <Input name="weight" id="weight" className="form-control" placeholder="Enter weight" type="number" value={validation.values.weight || 0} onChange={validation.handleChange} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} />
                                      </div>
                                      <div className="mb-3 col-lg-12 d-none">
                                        <label className="form-label" htmlFor="weight">
                                          &nbsp;
                                        </label>
                                        <Select name="weightType" placeholder="Enter unit" value={validation.values.weightType} onChange={(e) => validation.setFieldValue("weightType", e)} options={[{ value: "Gr", label: "Gr" }]}></Select>
                                      </div>
                                      <div className="mb-3 col-lg-12 d-none">
                                        <label className="form-label" htmlFor="stock_minimum">
                                          Min Stock
                                        </label>
                                        <Input type="number" className="form-control" id="price" placeholder="Enter minimum stock" name="stock_minimum" value={validation.values.stock_minimum || 0} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("stock_minimum", e.target.value)} />
                                      </div>
                                      <div className="mb-3 col-lg-12 d-none">
                                        <label className="form-label" htmlFor="sku">
                                          SKU
                                        </label>
                                        <Input name="sku" id="sku" className="form-control" placeholder="Enter sku" type="text" value={validation.values.sku} onChange={validation.handleChange} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} />
                                      </div>
                                      <div className="mb-3 col-lg-12 d-none">
                                        <label className="form-label" htmlFor="barcode">
                                          Barcode
                                        </label>
                                        <Input name="barcode" id="barcode" className="form-control" placeholder="Enter barcode" type="text" value={validation.values.barcode} onChange={validation.handleChange} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} />
                                      </div>
                                      <div className="mb-3 col-lg-12">
                                        <label className="form-label" htmlFor="price_book">
                                          Harga Booking
                                        </label>
                                        <Input type="number" className="form-control" id="price_book" placeholder="Isi harga booking" name="price_book" value={validation.values.price_book || 0} onFocus={(e) => e.target.select()} onBlur={validation.handleBlur} onChange={(e) => validation.setFieldValue("price_book", e.target.value)} />
                                      </div>
                                      <div className={isEdit ? "mb-3 col-lg-12" : "mb-3 col-lg-12 d-none"}>
                                        <label className="form-label" htmlFor="stocks">
                                          Stok
                                        </label>
                                        <Input type="number" className="form-control" id="price" placeholder="Enter minimum stock" name="stocks" value={validation.values.stocks || 1} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("stocks", e.target.value)} />
                                      </div>
                                      <div className="mb-3 col-lg-12">
                                        <label className="form-label" htmlFor="latitude">
                                          Latitude
                                        </label>
                                        <Input type="text" className="form-control" id="latitude" placeholder="isi posisi latitude" name="latitude" value={validation.values.latitude || 0} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("latitude", e.target.value)} />
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <Row>
                                        <div className="mb-3 col-lg-6">
                                          <label className="form-label" htmlFor="weight">
                                            Satuan Ukur
                                          </label>
                                          <Select name="uom" placeholder="Satuan" value={validation.values.uom} onChange={(e) => validation.setFieldValue("uom", e)} options={uomList}></Select>
                                        </div>

                                        <div className="mb-3 col-lg-6">
                                          <label className="form-label" htmlFor="land_excess">
                                            Kelebihan Tanah
                                          </label>
                                          <Input type="number" className="form-control" id="land_excess" placeholder="isi kelebihan tanah" name="land_excess" value={validation.values.land_excess || 0} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("land_excess", e.target.value)} />
                                        </div>
                                        <div className="mb-3 col-lg-6">
                                          <label className="form-label" htmlFor="land_size">
                                            Luas Tanah
                                          </label>
                                          <Input type="number" className="form-control" id="land_size" placeholder="isi luas tanah" name="land_size" value={validation.values.land_size || 0} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("land_size", e.target.value)} />
                                        </div>

                                        <div className="mb-3 col-lg-6">
                                          <label className="form-label" htmlFor="building_size">
                                            Luas Bangunan
                                          </label>
                                          <Input type="number" className="form-control" id="building_size" placeholder="isi luas bangunan" name="building_size" value={validation.values.building_size || 0} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("building_size", e.target.value)} />
                                        </div>
                                        <div className="mb-3 col-lg-12">
                                          <label className="form-label" htmlFor="land_price">
                                            Harga Kelebihan Tanah
                                          </label>
                                          <Input type="number" className="form-control" id="land_price" placeholder="isi harga tanah" name="land_price" value={validation.values.land_price || 0} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("land_price", e.target.value)} />
                                        </div>
                                        <div className={isEdit ? "mb-3 col-lg-12" : "mb-3 col-lg-12 d-none"}>
                                          <label className="form-label" htmlFor="orders">
                                            Order
                                          </label>
                                          <Input type="number" className="form-control" id="price" placeholder="Enter minimum stock" name="orders" value={validation.values.orders || 0} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("orders", e.target.value)} />
                                        </div>
                                        <div className="mb-3 col-lg-12">
                                          <label className="form-label" htmlFor="longitude">
                                            Longitude
                                          </label>
                                          <Input type="text" className="form-control" id="longitude" placeholder="isi posisi longitude" name="longitude" value={validation.values.longitude || 0} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("longitude", e.target.value)} />
                                        </div>
                                      </Row>
                                    </Col>
                                    <Row>
                                      <div className="mb-1">
                                        <Input name="isTaxable" id="isTaxable-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isTaxable} /> &nbsp;
                                        <Label htmlFor="isTaxable-field" className="form-label">
                                          Unit di kenai pajak
                                        </Label>
                                      </div>
                                      <div className="mb-1">
                                        <Input name="isContinueSelling" id="isContinueSelling-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isContinueSelling} /> &nbsp;
                                        <Label htmlFor="isContinueSelling-field" className="form-label">
                                          Dapat di beli saat tidak ada stok
                                        </Label>
                                      </div>
                                    </Row>
                                  </Row>
                                </TabPane>
                                <TabPane id="addproduct-metadata" tabId="2">
                                  <Row>
                                    <Col lg={6}>
                                      <div className="mb-3">
                                        <Label className="form-label" htmlFor="meta-title-input">
                                          Meta title
                                        </Label>
                                        <Input type="text" className="form-control" placeholder="Enter meta title" id="meta-title-input" name="meta_title" value={validation.values.meta_title ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} />
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <div className="mb-3">
                                        <Label className="form-label" htmlFor="meta-keywords-input">
                                          Meta Keywords
                                        </Label>
                                        <Input type="text" className="form-control" placeholder="Enter meta keywords" id="meta-keywords-input" name="meta_keyword" value={validation.values.meta_keyword ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange} />
                                      </div>
                                    </Col>
                                    <Col lg={12}>
                                      <div>
                                        <Label className="form-label" htmlFor="meta-description-input">
                                          Meta Description
                                        </Label>
                                        <textarea className="form-control" id="meta-description-input" placeholder="Enter meta description" name="meta_description" rows="3" value={validation.values.meta_description ?? ""} onBlur={validation.handleBlur} onChange={validation.handleChange}></textarea>
                                      </div>
                                    </Col>
                                  </Row>
                                </TabPane>
                              </TabContent>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col lg={4}>
                          <Card>
                            <CardHeader className="bg-light ps-3 pe-3 pt-3 pb-2">
                              <h5 className="card-title mb-0">Kategori & Status Unit</h5>
                            </CardHeader>
                            <CardBody>
                              <div className="mb-3 d-none col-lg-6">
                                <label className="form-label" htmlFor="brand">
                                  Merk
                                </label>
                                <Select
                                  name="brand"
                                  value={validation.values.brand}
                                  placeholder="Pilih merk"
                                  onChange={(e) => {
                                    validation.setFieldValue("brand", e);
                                  }}
                                  options={brandList}
                                ></Select>
                                {validation.touched.brand && validation.errors.brand && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.brand}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3 d-none">
                                <label className="mb-2">Type Unit</label>
                                <Select
                                  name="productType"
                                  value={validation.values.productType}
                                  placeholder="Pilih Tipe Unit"
                                  onChange={(e) => {
                                    validation.setFieldValue("productType", e);
                                  }}
                                  cacheOptions
                                  options={productTypeList}
                                ></Select>
                                {validation.touched.productType && validation.errors.productType && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.productType}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3">
                                <p className="mb-0">
                                  <Link to="#" className="float-end text-decoration-underline" onClick={() => toggleTag()}>
                                    Tambah
                                  </Link>
                                  <label>Tag Unit</label>
                                </p>
                                <Select
                                  name="tag"
                                  value={validation.values.tag}
                                  placeholder="Pilih Tag Unit"
                                  isMulti
                                  onChange={(opt, { option }) => {
                                    let newOpts = opt;
                                    if (option && option.value === "all") {
                                      let filteredOptions = clone(productTagList);
                                      filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                      newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                    }
                                    validation.setFieldValue("tag", newOpts);
                                  }}
                                  options={productTagList}
                                ></Select>
                              </div>
                              <div className="mb-3">
                                <Label htmlFor="choices-publish-status-input" className="form-label">
                                  Status
                                </Label>
                                <Select
                                  name="status"
                                  placeholder="Pilih status"
                                  value={validation.values.status}
                                  onChange={(e) => {
                                    validation.setFieldValue("status", e);
                                  }}
                                  options={statusActiveData}
                                ></Select>
                                {validation.touched.status && validation.errors.status && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.status}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3 d-none">
                                <Label htmlFor="visibility" className="form-label">
                                  Visibilitas
                                </Label>
                                <Select
                                  name="visibility"
                                  placeholder="Pilih visibilitas"
                                  value={validation.values.visibility}
                                  onChange={(e) => {
                                    validation.setFieldValue("visibility", e);
                                  }}
                                  options={statusVisibilityData}
                                ></Select>
                                {validation.touched.visibility && validation.errors.visibility && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.visibility}
                                  </small>
                                )}
                              </div>
                              <div className="d-none">
                                <label htmlFor="datepicker-publish-input" className="form-label">
                                  Tanggal dipublikasikan
                                </label>
                                <Flatpickr
                                  name="date-picker"
                                  className="form-control"
                                  placeholder="Isi tanggal publikasi"
                                  options={{
                                    enableTime: true,
                                    time_24hr: true,
                                    dateFormat: "Y/m/d H:i",
                                  }}
                                  value={validation.values.publishedat ?? ""}
                                  onChange={(obj, str) => {
                                    validation.setFieldValue("publishedat", str);
                                  }}
                                />
                                {validation.touched.publishedat && validation.errors.publishedat && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.publishedat}
                                  </small>
                                )}
                              </div>
                            </CardBody>
                          </Card>
                          <Card>
                            <CardHeader className="bg-light ps-3 pe-3 pt-3 pb-2">
                              <h5 className="card-title mb-0">Deskripsi singkat</h5>
                            </CardHeader>
                            <CardBody>
                              <p className="text-muted mb-2">Keterangan</p>
                              <textarea className="form-control" placeholder="Input keterangan singkat jika ada (max 100 karakter)" rows="3"></textarea>
                            </CardBody>
                          </Card>
                          <Card>
                            <CardHeader className="bg-light ps-3 pe-3 pt-3 pb-2">
                              <h5 className="card-title mb-0">Pengaturan Akuntansi</h5>
                            </CardHeader>
                            <CardBody className="row">
                              <div className="mb-3">
                                <label className="form-label" htmlFor="company">
                                  Akun Persediaan
                                </label>
                                <Select
                                  name="account"
                                  value={validation.values.account}
                                  placeholder="Pilih akun persediaan"
                                  onChange={(e) => {
                                    validation.setFieldValue("account", e);
                                  }}
                                  options={accountingList}
                                ></Select>
                                {validation.touched.account && validation.errors.account && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.account}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="company">
                                  Akun Pendapatan
                                </label>
                                <Select
                                  name="accountSales"
                                  value={validation.values.accountSales}
                                  placeholder="Pilih akun pendapatan"
                                  onChange={(e) => {
                                    validation.setFieldValue("accountSales", e);
                                  }}
                                  options={accountingList}
                                ></Select>
                                {validation.touched.accountSales && validation.errors.accountSales && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.accountSales}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3">
                                <label className="form-label" htmlFor="company">
                                  Akun Biaya Pokok Persediaan
                                </label>
                                <Select
                                  name="accountPurchase"
                                  value={validation.values.accountPurchase}
                                  placeholder="Pilih biaya pokok persediaan"
                                  onChange={(e) => {
                                    validation.setFieldValue("accountPurchase", e);
                                  }}
                                  options={accountingList}
                                ></Select>
                                {validation.touched.accountPurchase && validation.errors.accountPurchase && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.accountPurchase}
                                  </small>
                                )}
                              </div>
                            </CardBody>
                          </Card>
                          <button type="submit" className="btn btn-success w-100 mt-3" disabled={loading}>
                            <span className="d-flex align-items-center">
                              <span className="flex-grow-1 me-2">{!!isEdit ? "Simpan" : "Tambah Unit Rumah"}</span>
                              {loading && (
                                <Spinner size="sm" className="flex-shrink-0" role="status">
                                  Loading...
                                </Spinner>
                              )}
                            </span>
                          </button>
                          <button
                            type="button"
                            className="btn btn-light mt-2 w-100"
                            onClick={() => {
                              setModal(false);
                              setProductFiles([]);
                            }}
                          >
                            Tutup
                          </button>
                        </Col>
                      </Row>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end"></div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalTag" isOpen={modalTag} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleTag}>
                    Add Tag Unit
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationTag.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="tag_name-field" className="form-label">
                            Tag Name
                          </Label>
                          <Input name="tag_name" id="tag_name-field" className="form-control" placeholder="Enter Tag Name" type="text" onChange={validationTag.handleChange} onBlur={validationTag.handleBlur} invalid={validationTag.touched.tag_name && validationTag.errors.tag_name ? true : false} />
                          {validationTag.touched.tag_name && validationTag.errors.tag_name ? <FormFeedback type="invalid">{validationTag.errors.tag_name}</FormFeedback> : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalTag(false);
                          }}
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Add Tag Unit</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalCategory" isOpen={modalCategory} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleCategory}>
                    Add Type Unit
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationCategory.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3">
                          <Label htmlFor="brandCategory" className="form-label">
                            Merek
                          </Label>
                          <Select
                            name="brandCategory"
                            placeholder="Pilih merek"
                            onChange={(e) => {
                              validationCategory.setFieldValue("brandCategory", e);
                            }}
                            options={brandList}
                            invalid={validationCategory.touched.brandCategory && validationCategory.errors.brandCategory ? true : false}
                          ></Select>
                          {validationCategory.touched.brandCategory && validationCategory.errors.brandCategory ? (
                            <p className="text-danger" type="invalid">
                              {validationCategory.errors.brandCategory}
                            </p>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="name-field" className="form-label">
                            Category Name
                          </Label>
                          <Input name="name" id="name-field" className="form-control" placeholder="Enter Category Name" type="text" onChange={validationCategory.handleChange} onBlur={validationCategory.handleBlur} invalid={validationCategory.touched.name && validationCategory.errors.name ? true : false} />
                          {validationCategory.touched.name && validationCategory.errors.name ? <FormFeedback type="invalid">{validationCategory.errors.name}</FormFeedback> : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalCategory(false);
                          }}
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Add Group Category</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalCategory" isOpen={modalDetail} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    Detail Product
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationCategory.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <Row className="gx-lg-5">
                                <Col xl={4} md={8} className="mx-auto">
                                  <div className="product-img-slider sticky-side-div">
                                    <Swiper
                                      navigation={true}
                                      thumbs={{
                                        swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
                                      }}
                                      className="swiper product-thumbnail-slider p-2 rounded bg-light"
                                    >
                                      <div className="swiper-wrapper">
                                        {info.product_var &&
                                          info.product_var.map((file, idxFile) => {
                                            return (
                                              <SwiperSlide key={"file-" + idxFile}>
                                                <img src={file.image === "" ? logo : `${api.MEDIA_URL}/media/${file.image}-w-150`} alt="" className="img-fluid d-block" style={{ height: "300px" }} />
                                              </SwiperSlide>
                                            );
                                          })}
                                      </div>
                                    </Swiper>

                                    <div className="product-nav-slider mt-2">
                                      <Swiper onSwiper={setThumbsSwiper} slidesPerView={4} freeMode={true} watchSlidesProgress={true} spaceBetween={10} className="swiper product-nav-slider mt-2 overflow-hidden">
                                        <div className="swiper-wrapper">
                                          {info.product_var &&
                                            info.product_var.map((file, idxFile) => {
                                              return (
                                                <SwiperSlide className="rounded" key={"files-" + idxFile}>
                                                  <div className="nav-slide-item">
                                                    <img src={file.image === "" ? logo : `${api.MEDIA_URL}/media/${file.image}-w-150`} alt="" className="img-fluid d-block rounded" />
                                                  </div>
                                                </SwiperSlide>
                                              );
                                            })}
                                        </div>
                                      </Swiper>
                                    </div>
                                  </div>
                                </Col>

                                <Col xl={8}>
                                  <div className="mt-xl-0 mt-5">
                                    <div className="d-flex">
                                      <div className="flex-grow-1">
                                        <h4>{info.name ? info.name : "-"}</h4>
                                        <div className="hstack gap-3 flex-wrap">
                                          <div>
                                            <Link to="#" className="text-primary d-block">
                                              {info.product_createdby ? info.product_createdby.name : "-"}
                                            </Link>
                                          </div>
                                          <div className="vr"></div>
                                          <div className="text-muted">
                                            Seller : <span className="text-body fw-medium">{info.product_company ? info.product_company.name : "-"}</span>
                                          </div>
                                          <div className="vr"></div>
                                          <div className="text-muted">
                                            Published : <span className="text-body fw-medium">{handleValidDate(info.publishedat)}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="d-flex flex-wrap gap-2 align-items-center mt-3">
                                      <div className="text-muted fs-16">
                                        <span className="mdi mdi-star text-warning"></span>
                                        <span className="mdi mdi-star text-warning"></span>
                                        <span className="mdi mdi-star text-warning"></span>
                                        <span className="mdi mdi-star text-warning"></span>
                                        <span className="mdi mdi-star text-warning"></span>
                                      </div>
                                      <div className="text-muted">( 5.50k Customer Review )</div>
                                    </div>

                                    <Row className="mt-4">
                                      {productDetailsWidgets.map((pricingDetails, key) => (
                                        <PricingWidgetList pricingDetails={pricingDetails} key={key} />
                                      ))}
                                    </Row>

                                    <div className="mt-4 text-muted">
                                      <h5 className="fs-14">Description :</h5>
                                      <p>{info && info.description ? info.description.replace(/<[^>]+>/g, "") : "-"}</p>
                                    </div>

                                    <Row className="d-none">
                                      <Col sm={6}>
                                        <div className="mt-3">
                                          <h5 className="fs-14">Features :</h5>
                                          <ul className="list-unstyled">
                                            <li className="py-1">
                                              <i className="mdi mdi-circle-medium me-1 text-muted align-middle"></i> Full Sleeve
                                            </li>
                                            <li className="py-1">
                                              <i className="mdi mdi-circle-medium me-1 text-muted align-middle"></i> Cotton
                                            </li>
                                            <li className="py-1">
                                              <i className="mdi mdi-circle-medium me-1 text-muted align-middle"></i> All Sizes available
                                            </li>
                                            <li className="py-1">
                                              <i className="mdi mdi-circle-medium me-1 text-muted align-middle"></i> 4 Different Color
                                            </li>
                                          </ul>
                                        </div>
                                      </Col>
                                      <Col sm={6}>
                                        <div className="mt-3">
                                          <h5 className="fs-14">Services :</h5>
                                          <ul className="list-unstyled product-desc-list">
                                            <li className="py-1">10 Days Replacement</li>
                                            <li className="py-1">Cash on Delivery available</li>
                                          </ul>
                                        </div>
                                      </Col>
                                    </Row>

                                    <div className="product-content mt-5">
                                      <h5 className="fs-14 mb-3">Keterangan Unit :</h5>
                                      <Nav tabs className="nav-tabs-custom nav-success">
                                        <NavItem>
                                          <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                              active: customActiveTab === "1",
                                            })}
                                            onClick={() => {
                                              toggleCustom("1");
                                            }}
                                          >
                                            Specification
                                          </NavLink>
                                        </NavItem>
                                        <NavItem>
                                          <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                              active: customActiveTab === "2",
                                            })}
                                            onClick={() => {
                                              toggleCustom("2");
                                            }}
                                          >
                                            Details
                                          </NavLink>
                                        </NavItem>
                                      </Nav>

                                      <TabContent activeTab={customActiveTab} className="border border-top-0 p-4" id="nav-tabContent">
                                        <TabPane id="nav-speci" tabId="1">
                                          <div className="table-responsive">
                                            <table className="table mb-0">
                                              <tbody>
                                                <tr>
                                                  <th scope="row" style={{ width: "200px" }}>
                                                    Category
                                                  </th>
                                                  <td>{info && info.product_category ? info.product_category.name : "-"}</td>
                                                </tr>
                                                <tr>
                                                  <th scope="row">Brand</th>
                                                  <td>{info && info.product_brand ? info.product_brand.name : "-"}</td>
                                                </tr>
                                                <tr>
                                                  <th scope="row">Weight</th>
                                                  <td>{info && info.weight ? info.weight + " " + info.weightType : "-"}</td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </TabPane>
                                        <TabPane id="nav-detail" tabId="2">
                                          <div>
                                            <h5 className="font-size-16 mb-3">{info ? info.name : "-"}</h5>
                                            <p>{info && info.description ? info.description.replace(/<[^>]+>/g, "") : "-"}</p>
                                            <div className="d-none">
                                              <p className="mb-2">
                                                <i className="mdi mdi-circle-medium me-1 text-muted align-middle"></i> Machine Wash
                                              </p>
                                              <p className="mb-2">
                                                <i className="mdi mdi-circle-medium me-1 text-muted align-middle"></i> Fit Type: Regular
                                              </p>
                                              <p className="mb-2">
                                                <i className="mdi mdi-circle-medium me-1 text-muted align-middle"></i> 100% Cotton
                                              </p>
                                              <p className="mb-0">
                                                <i className="mdi mdi-circle-medium me-1 text-muted align-middle"></i> Long sleeve
                                              </p>
                                            </div>
                                          </div>
                                        </TabPane>
                                      </TabContent>
                                    </div>

                                    <div className="mt-5 d-none">
                                      <div>
                                        <h5 className="fs-14 mb-3">Ratings & Reviews</h5>
                                      </div>
                                      <Row className="gy-4 gx-0">
                                        <Col lg={4}>
                                          <div>
                                            <div className="pb-3">
                                              <div className="bg-light px-3 py-2 rounded-2 mb-2">
                                                <div className="d-flex align-items-center">
                                                  <div className="flex-grow-1">
                                                    <div className="fs-16 align-middle text-warning">
                                                      <i className="ri-star-fill"></i> <i className="ri-star-fill"></i> <i className="ri-star-fill"></i> <i className="ri-star-fill"></i> <i className="ri-star-half-fill"></i>
                                                    </div>
                                                  </div>
                                                  <div className="flex-shrink-0">
                                                    <h6 className="mb-0">4.5 out of 5</h6>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="text-center">
                                                <div className="text-muted">
                                                  Total <span className="fw-medium">5.50k</span> reviews
                                                </div>
                                              </div>
                                            </div>

                                            <div className="mt-3">
                                              <Row className="align-items-center g-2">
                                                <div className="col-auto">
                                                  <div className="p-2">
                                                    <h6 className="mb-0">5 star</h6>
                                                  </div>
                                                </div>
                                                <div className="col">
                                                  <div className="p-2">
                                                    <div className="progress animated-progess progress-sm">
                                                      <div
                                                        className="progress-bar bg-success"
                                                        role="progressbar"
                                                        style={{
                                                          width: "50.16%",
                                                        }}
                                                        aria-valuenow="50.16"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                      ></div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="col-auto">
                                                  <div className="p-2">
                                                    <h6 className="mb-0 text-muted">2758</h6>
                                                  </div>
                                                </div>
                                              </Row>

                                              <Row className="align-items-center g-2">
                                                <div className="col-auto">
                                                  <div className="p-2">
                                                    <h6 className="mb-0">4 star</h6>
                                                  </div>
                                                </div>
                                                <div className="col">
                                                  <div className="p-2">
                                                    <div className="progress animated-progess progress-sm">
                                                      <div
                                                        className="progress-bar bg-success"
                                                        role="progressbar"
                                                        style={{
                                                          width: "19.32%",
                                                        }}
                                                        aria-valuenow="19.32"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                      ></div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="col-auto">
                                                  <div className="p-2">
                                                    <h6 className="mb-0 text-muted">1063</h6>
                                                  </div>
                                                </div>
                                              </Row>

                                              <Row className="align-items-center g-2">
                                                <div className="col-auto">
                                                  <div className="p-2">
                                                    <h6 className="mb-0">3 star</h6>
                                                  </div>
                                                </div>
                                                <div className="col">
                                                  <div className="p-2">
                                                    <div className="progress animated-progess progress-sm">
                                                      <div
                                                        className="progress-bar bg-success"
                                                        role="progressbar"
                                                        style={{
                                                          width: "18.12%",
                                                        }}
                                                        aria-valuenow="18.12"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                      ></div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="col-auto">
                                                  <div className="p-2">
                                                    <h6 className="mb-0 text-muted">997</h6>
                                                  </div>
                                                </div>
                                              </Row>

                                              <Row className="align-items-center g-2">
                                                <div className="col-auto">
                                                  <div className="p-2">
                                                    <h6 className="mb-0">2 star</h6>
                                                  </div>
                                                </div>
                                                <div className="col">
                                                  <div className="p-2">
                                                    <div className="progress animated-progess progress-sm">
                                                      <div
                                                        className="progress-bar bg-warning"
                                                        role="progressbar"
                                                        style={{
                                                          width: "7.42%",
                                                        }}
                                                        aria-valuenow="7.42"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                      ></div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="col-auto">
                                                  <div className="p-2">
                                                    <h6 className="mb-0 text-muted">408</h6>
                                                  </div>
                                                </div>
                                              </Row>

                                              <Row className="align-items-center g-2">
                                                <div className="col-auto">
                                                  <div className="p-2">
                                                    <h6 className="mb-0">1 star</h6>
                                                  </div>
                                                </div>
                                                <div className="col">
                                                  <div className="p-2">
                                                    <div className="progress animated-progess progress-sm">
                                                      <div
                                                        className="progress-bar bg-danger"
                                                        role="progressbar"
                                                        style={{
                                                          width: "4.98%",
                                                        }}
                                                        aria-valuenow="4.98"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                      ></div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="col-auto">
                                                  <div className="p-2">
                                                    <h6 className="mb-0 text-muted">274</h6>
                                                  </div>
                                                </div>
                                              </Row>
                                            </div>
                                          </div>
                                        </Col>

                                        <Col lg={8}>
                                          <div className="ps-lg-4">
                                            <div className="d-flex flex-wrap align-items-start gap-3">
                                              <h5 className="fs-14">Reviews: </h5>
                                            </div>

                                            <SimpleBar className="me-lg-n3 pe-lg-4" style={{ maxHeight: "225px" }}>
                                              <ul className="list-unstyled mb-0">
                                                {/* {reviews.map((review, key) => (
                                                  <React.Fragment key={key}>
                                                    <ProductReview review={review} />
                                                  </React.Fragment>
                                                ))} */}
                                              </ul>
                                            </SimpleBar>
                                          </div>
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalDetail(false);
                            setInfo([]);
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Product;
